export default "__VITE_ASSET__BzG8BSm___"